import script from "./WinesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WinesPage.vue?vue&type=script&setup=true&lang=js"

import "./WinesPage.vue?vue&type=style&index=0&id=7cafbdc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cafbdc0"]])

export default __exports__